import { useCallback, useState } from 'react';
import { useSchool } from '@/contexts/SchoolContext';
import { useRoleSwitcher } from '@/features/auth/hooks/useRoleSwitcher';
import { useNotifications } from '@/components/notifications/NotificationSystem';
import { openLearnerCaseRecord } from '../services/learnerCaseRecordService';

export default function useLearnerCaseRecordAction(studentId) {
  const { schoolId } = useSchool();
  const { currentRole } = useRoleSwitcher();
  const { showError } = useNotifications();
  const [isPreparing, setIsPreparing] = useState(false);
  const canPrint = Boolean(
    schoolId && studentId && ['admin', 'dev'].includes(currentRole)
  );

  const printCaseRecord = useCallback(async () => {
    if (!canPrint || isPreparing) return;
    setIsPreparing(true);
    try {
      await openLearnerCaseRecord(schoolId, studentId);
    } catch (error) {
      console.error('Error opening learner case record:', error);
      showError(
        'Could not open the learner case record',
        'Please try again or ask an administrator to check the document service.'
      );
    } finally {
      setIsPreparing(false);
    }
  }, [canPrint, isPreparing, schoolId, showError, studentId]);

  return { canPrint, isPreparing, printCaseRecord };
}
